export default __webpack_public_path__ + "static/media/vaccine.3e53873e.svg";